<script setup lang="ts">
import { Icon } from "@iconify/vue";

import BrandLogo from "./BrandLogo.vue";
import { useTheme } from "../composables/useTheme";

const { theme, toggleTheme } = useTheme();

const webBaseUrl = (import.meta.env.VITE_WEB_BASE_URL ?? "https://termine.schnittpunktlehrte.de").replace(/\/$/, "");

const currentYear = new Date().getFullYear();

const legalLinks = [
  {
    href: `${webBaseUrl}/impressum`,
    label: "Impressum",
  },
  {
    href: `${webBaseUrl}/agb`,
    label: "AGB",
  },
  {
    href: `${webBaseUrl}/datenschutz`,
    label: "Datenschutz",
  },
  {
    href: `${webBaseUrl}/stornierung`,
    label: "Stornierung",
  },
];
</script>

<template>
  <footer class="mt-24 border-t border-app-border bg-app-shell/60 backdrop-blur-md">
    <div class="mx-auto max-w-6xl px-6 py-10">
      <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <BrandLogo class="h-16 w-auto shrink-0 self-start md:h-20 md:self-auto" />
        <p class="text-sm text-app-text-muted md:text-right">
          Zeiterfassung für unser Team.
        </p>
      </div>

      <div class="mt-10 flex flex-col items-center justify-between gap-4 border-t border-app-border pt-6 text-xs text-app-text-subtle sm:flex-row">
        <p class="order-2 sm:order-1">
          © {{ currentYear }} Schnittpunkt Lehrte
        </p>
        <nav class="order-1 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 sm:order-2">
          <template v-for="(link, index) in legalLinks" :key="link.href">
            <a class="text-app-text-muted transition-colors hover:text-app-text" :href="link.href"
              target="_blank" rel="noopener noreferrer">
              {{ link.label }}
            </a>
            <span v-if="index < legalLinks.length - 1" class="hidden text-app-text-subtle sm:inline">·</span>
          </template>
        </nav>
        <button type="button"
          class="order-3 inline-flex h-10 w-10 items-center justify-center rounded-full border border-app-border text-app-text-muted transition hover:bg-app-surface hover:text-app-text"
          :aria-label="theme === 'dark' ? 'Helles Design aktivieren' : 'Dunkles Design aktivieren'"
          @click="toggleTheme">
          <Icon :icon="theme === 'dark' ? 'heroicons:sun' : 'heroicons:moon'" class="h-5 w-5" />
        </button>
      </div>
    </div>
  </footer>
</template>
